import React from 'react';
import './skeleton.css';

/**
 * 메인 콘텐츠 영역 스켈레톤 UI 컴포넌트
 * 페이지 데이터가 로딩 중일 때 표시
 */
const ContentSkeleton = () => {
  return (
    <div className="content-skeleton">
      {/* 그리드 카드 스켈레톤 */}
      <div className="row g-4">
        {[1, 2, 3, 4].map((item) => (
          <div key={item} className="col-12 col-md-6 col-lg-3">
            <div className="card h-100">
              <div className="card-body">
                <div className="skeleton-line mb-3" style={{ width: '50%', height: '20px' }}></div>
                <div className="skeleton-line mb-2" style={{ width: '80%', height: '16px' }}></div>
                <div className="skeleton-line" style={{ width: '60%', height: '16px' }}></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* 테이블/리스트 스켈레톤 */}
      <div className="card mt-4">
        <div className="card-body">
          <div className="skeleton-line mb-4" style={{ width: '30%', height: '24px' }}></div>
          <div className="skeleton-table">
            {[1, 2, 3, 4, 5].map((row) => (
              <div key={row} className="skeleton-table-row d-flex mb-3">
                <div className="skeleton-line" style={{ width: '20%', height: '20px', marginRight: '16px' }}></div>
                <div className="skeleton-line" style={{ width: '30%', height: '20px', marginRight: '16px' }}></div>
                <div className="skeleton-line" style={{ width: '25%', height: '20px', marginRight: '16px' }}></div>
                <div className="skeleton-line" style={{ width: '25%', height: '20px' }}></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContentSkeleton;

